/**
 * Generates a random password that meets the given policy requirements
 * @param {Object} policy - Password policy object
 * @param {number} policy.minLength - Minimum password length
 * @param {boolean} policy.requireLowercase - Require at least one lowercase letter
 * @param {boolean} policy.requireUppercase - Require at least one uppercase letter
 * @param {boolean} policy.requireNumber - Require at least one number
 * @param {boolean} policy.excludeSpecial - Only allow letters and numbers
 * @returns {string} - Generated password
 */
export const generatePassword = (policy) => {
  const length = Math.max(policy?.minLength || 12, 12)
  const lowercase = 'abcdefghijklmnopqrstuvwxyz'
  const uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
  const numbers = '0123456789'
  const special = '!@#$%^&*'

  let chars = ''
  let password = ''

  // Add required character types to ensure policy compliance
  if (policy?.requireLowercase) {
    password += lowercase[Math.floor(Math.random() * lowercase.length)]
    chars += lowercase
  }
  if (policy?.requireUppercase) {
    password += uppercase[Math.floor(Math.random() * uppercase.length)]
    chars += uppercase
  }
  if (policy?.requireNumber) {
    password += numbers[Math.floor(Math.random() * numbers.length)]
    chars += numbers
  }

  // Build character set for remaining characters
  if (policy?.excludeSpecial) {
    chars = chars || (lowercase + uppercase + numbers)
  } else {
    chars = chars || (lowercase + uppercase + numbers + special)
  }

  // Fill remaining length with random characters
  while (password.length < length) {
    password += chars[Math.floor(Math.random() * chars.length)]
  }

  // Shuffle the password to randomize required character positions
  return password.split('').sort(() => Math.random() - 0.5).join('')
}
